import axios from "axios";
import { logoutUser } from "./redux/actions/profile";
import { store } from "./redux/store";
import { showTimeExpiredModal } from "./redux/actions/utils";

axios.interceptors.request.use(
  function (config) {
    const lastLoggedInTime = localStorage.getItem("lastLoggedInTime");
    const lastValidatedLoggedInTime = localStorage.getItem("lastValidatedLoggedInTime");
    if (lastLoggedInTime && lastValidatedLoggedInTime) {
      const timeElapsed = Date.now() - lastLoggedInTime;
      if (timeElapsed > 3600000) {
        localStorage.removeItem("lastValidatedLoggedInTime");
        store.dispatch(logoutUser()).then(() => window.location.href = "/login");
        // Abort the request — session has expired
        const controller = new AbortController();
        controller.abort();
        config.signal = controller.signal;
        return config;
      } else if (timeElapsed > 1800000) {
        store.dispatch(showTimeExpiredModal());
        // Abort the request — let user decide to stay or logout
        const controller = new AbortController();
        controller.abort();
        config.signal = controller.signal;
        return config;
      }else {
        const timeNow = Date.now();
        localStorage.setItem("lastLoggedInTime", timeNow)
        localStorage.setItem("lastValidatedLoggedInTime", timeNow)
      }
    }
    if (localStorage.getItem("token")) {
      config.headers["content-type"] = `application/json`
      config.headers["Authorization"] = `Token ${localStorage.getItem("token")}`;
    }
    return config;
  }
);

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    // Only handle 401s — ignore aborted requests from the request interceptor
    if (error?.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("UserId");
      localStorage.removeItem("lastLoggedInTime");
      localStorage.removeItem("lastValidatedLoggedInTime");
      store.dispatch({ type: "LOGOUT_USER", payload: {} });
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default axios;
